var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "body",
      {
        staticClass:
          "home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container",
        staticStyle: { "overflow-y": "unset" },
        attrs: { "data-anchor": "pagetop" }
      },
      [
        _c("navbar", {
          attrs: {
            follow: "st-Header",
            imgSrc: "../../../../static/img/landing/logo_black.png",
            searchImgSrc: "../../../../static/img/landing/search_black.png"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "st-FixedPoint" }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("copyright")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "st-MainContainer" }, [
      _c(
        "main",
        {
          staticClass: "st-MainContents",
          staticStyle: { "padding-top": "120px" }
        },
        [
          _c("header", { staticClass: "innovation-PageTitle" }, [
            _c("div", { staticClass: "innovation-PageTitle_Inner" }, [
              _c(
                "h1",
                {
                  staticClass: "company-PageTitle_Inner_Title",
                  attrs: { "data-appear": "" }
                },
                [
                  _c("span", { staticClass: "company-PageTitle_Logo" }, [
                    _c("b", [_vm._v("INNOVATION")])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "company-PageTitle_Title" }, [
                    _c("b", [_vm._v("経営革新")])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sw-parallax" }, [
                _c(
                  "div",
                  { staticClass: "sw-parallax_outer js-parallax_outer" },
                  [
                    _c("div", { staticClass: "sw-parallax_inner" }, [
                      _c(
                        "div",
                        { staticClass: "sw-parallax_block js-parallax_block" },
                        [
                          _c("div", { staticClass: "sw-parallax_target" }, [
                            _c(
                              "div",
                              { staticClass: "company-PageTitle_Slide" },
                              [
                                _c("div", {
                                  staticClass:
                                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image1",
                                  staticStyle: {
                                    background:
                                      "url(../../../../static/img/landing/childpageimg3.png) 20%/cover no-repeat"
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "company-PageTitle_Slide-image company-PageTitle_Slide-image-image2",
                                  staticStyle: {
                                    background:
                                      "url(../../../../static/img/landing/childpageimg3.png) 20%/cover no-repeat"
                                  }
                                })
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "innovation-Guzzilla" }, [
            _c("div", { staticClass: "innovation-Guzzilla_Inner" }, [
              _c("h2", { staticClass: "innovation-Title" }, [
                _vm._v("経営革新計画の概要")
              ]),
              _vm._v(" "),
              _c("h3", { staticClass: "product-Detail_Column-text" }, [
                _c("b", [
                  _vm._v(
                    "オーダーメイドに応えるＮＣ旋盤用ロボットの開発、販売及びアフターサービスの展開"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "product-Detail_Column-text" }, [
                _vm._v(
                  "当社は、切削部品を中心に輸出入業務とNC旋盤、フライス盤を導入して自ら高精度部品の加工を行っている。"
                ),
                _c("br"),
                _vm._v(
                  "\n            今回の経営革新では、切削加工技術を保有している当社がユーザー目線で顧客の使用方法を収集して、希望の機能も付加するオーダーメイドのロボットを開発、販売する。\n            基本的には、チャッカ―タイプのNC旋盤は材料の供給や加工後のピックアップは手動で行っており、対策としてパーツフィーダ―の活用やロボットを使い自動化を推進しているが、\n            供給、排出作業の合理化だけに留まっている。そこで当社では、顧客の使用方法や要望事項を把握しさらなる合理化が可能なオーダーメイドのロボットを開発、販売する。\n            また、ロボット導入時の技術指導や対象となる加工部品が変わった場合の新たな仕様要求にも対応するアフターサービス及びロボットのメンテナンス作業も対応する。\n            NC旋盤用ロボットは被加工材の交換（供給、排出機能）に特化した物が多く、個々の顧客の要望に合わせた仕様で製作し技術指導を行い、量産稼働や対象部品が変わった場合までフォローしていく。"
                ),
                _c("br"),
                _vm._v(
                  "\n            本取り組みにより、ホームページやパンフレットの制作、展示会、商談会に参加し、周知していくことで当社の経営革新を達成する。"
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "innovation-Guzzilla_Slide swiper-container swiper-container-initialized swiper-container-horizontal",
                  attrs: { "data-appear": "true" }
                },
                [
                  _c("ul", { staticClass: "swiper-wrapper" }, [
                    _c("li", { staticClass: "swiper-slide" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "../../../../static/img/landing/innovation01.pdf",
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }
                        },
                        [
                          _c("picture", [
                            _c("img", {
                              attrs: {
                                src: require("../../../../static/img/landing/innovation01.png"),
                                alt: ""
                              }
                            })
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "swiper-slide" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "../../../../static/img/landing/innovation01.pdf",
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }
                        },
                        [
                          _c("picture", [
                            _c("img", {
                              attrs: {
                                src: require("../../../../static/img/landing/innovation02.png"),
                                alt: ""
                              }
                            })
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "swiper-slide" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "../../../../static/img/landing/innovation01.pdf",
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }
                        },
                        [
                          _c("picture", [
                            _c("img", {
                              attrs: {
                                src: require("../../../../static/img/landing/innovation03.png"),
                                alt: ""
                              }
                            })
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "swiper-slide" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "../../../../static/img/landing/innovation01.pdf",
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }
                        },
                        [
                          _c("picture", [
                            _c("img", {
                              attrs: {
                                src: require("../../../../static/img/landing/innovation04.png"),
                                alt: ""
                              }
                            })
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "swiper-button-next swiper-button-next-Guzzilla"
                    },
                    [_c("i", { staticClass: "icf el-icon-arrow-right" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "swiper-button-prev swiper-button-prev-Guzzilla"
                    },
                    [_c("i", { staticClass: "icf el-icon-arrow-left" })]
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "st-Breadcrumbs" }, [
        _c(
          "ul",
          {
            staticClass: "st-BreadcrumbsList",
            attrs: { itemscope: "itemscope", itemtype: "" }
          },
          [
            _c(
              "li",
              {
                staticClass: "st-BreadcrumbsList_Item",
                attrs: {
                  itemprop: "itemListElement",
                  itemscope: "itemscope",
                  itemtype: ""
                }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "st-BreadcrumbsList_Item-link",
                    attrs: { href: "/", itemprop: "item" }
                  },
                  [_vm._v("ホーム")]
                ),
                _vm._v(" "),
                _c("meta", { attrs: { itemprop: "position", content: "1" } })
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "st-BreadcrumbsList_Item",
                attrs: {
                  itemprop: "itemListElement",
                  itemscope: "itemscope",
                  itemtype: ""
                }
              },
              [
                _c(
                  "p",
                  {
                    staticStyle: { "margin-bottom": "0rem" },
                    attrs: { itemprop: "item", "aria-current": "page" }
                  },
                  [
                    _c("span", { attrs: { itemprop: "name" } }, [
                      _vm._v("経営革新")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("meta", { attrs: { itemprop: "position", content: "3" } })
              ]
            )
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-480c2738", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-480c2738","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/innovation/innovation.vue
// module id = null
// module chunks = 